<template>
  <div class="spin-button"
       role="spinbutton"
       :aria-valuemin="min"
       :aria-valuemax="max"
       :aria-valuenow="value"
       :tabindex="0"
       @keydown="onKeydown">

    <Button v-if="hideDecrement"
      preset-size
      @click.stop="$emit('edit')"
      :aria-label="$t(ariaLabel)"
      tabindex="-1"
      icon-left="pencil"
      :icon-only="true"
      :disabled="value === 0"
    />

    <Button v-if="!hideDecrement"
      preset-size
      @click.stop="decrement"
      :aria-label="$t(ariaLabel)"
      :disabled="value <= min"
      tabindex="-1"
      :icon-left="iconTypeOnDecrement"
      :icon-only="true"
    />

    <input
        type="number"
        :value="value"
        @input="onInput"
        :disabled="true"
        :min="min"
        :max="max"
        :aria-disabled="true"
        aria-valuemin="min"
        aria-valuemax="max"
        aria-valuenow="value"
        aria-label="$t('ariaLabel.quantity')"
    />

    <Button
      preset-size
      @click.stop="increment"
      aria-label="$t('ariaLabel.increaseItemQuantity')"
      :disabled="value >= max"
      tabindex="-1"
      icon-left="plus"
      :icon-only="true"
    />
  </div>
</template>

<script>
import Button from '@/components/actions/Button.vue';

export default {
  name: 'SpinButton',
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    hideDecrement: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button
  },
  data() {
    return {};
  },
  computed: {
    value() {
      return this.modelValue;
    },
    iconTypeOnDecrement() {
      if (this.value === 1) {
        return 'trash-can';
      }
      return 'minus';
    },
    ariaLabel() {
      if (this.value > 0) {
        return this.hideDecrement ? 'ariaLabel.edit' : 'ariaLabel.removeItem';
      }
      return 'ariaLabel.decreaseItemQuantity';
    },
  },
  watch: {
    // Remove local value management, always use modelValue
  },
  methods: {
    increment() {
      // Always allow increment if value < max
      if (this.value < this.max) {
        const newValue = Math.min(this.value + this.step, this.max);
        this.$emit('update:modelValue', { value: newValue, type: 'increment' });
      }
    },
    decrement() {
      if (this.value > this.min) {
        const newValue = Math.max(this.value - this.step, this.min);
        this.$emit('update:modelValue', { value: newValue, type: 'decrement' });
      }
    },
    onKeydown(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowRight') {
        this.increment();
        e.preventDefault();
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') {
        this.decrement();
        e.preventDefault();
      }
    },
    onInput(e) {
      const newValue = parseInt(e.target.value, 10);
      if (!isNaN(newValue) && newValue >= this.min && newValue <= this.max) {
        this.$emit('update:modelValue', { value: newValue, type: 'input' });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.spin-button {
  display: flex;
  width: 100%; /* full width */
  gap: 6px;
  /*align-items: baseline;*/
}
.spin-button button {
  flex: 0 0 36px;
  height: 36px;
  width: 36px;
  border-radius: 50%;
}
.spin-button input {
  flex: 1 1 auto;
  text-align: center;
  width: 100%;
  padding: 5px;
  margin: 0;
  font-size: 16px;
  box-sizing: border-box;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
